import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { HttpMethod } from '../enums/http-method.enum';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { SnackbarService } from '../services/snackbar.service';
import { inject } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBarService = inject(SnackbarService);
  const configuration = inject(ConfigurationService).configuration;
  const isModifyingRequest = [HttpMethod.POST, HttpMethod.PUT, HttpMethod.DELETE].includes(
    req.method as HttpMethod,
  );

  if (!snackBarService || !configuration || !isModifyingRequest) return next(req);

  const prepareErrorMessage = (error: HttpErrorResponse): string => {
    if (error.status === 0) {
      return 'Cannot reach the server.';
    }
    return `${error.error?.message ?? error.message} | Status Code: ${error.status}`;
  };

  if (
    [configuration.api.backendUrl, configuration.api.ebicsBackendUrl].some((base) =>
      req.url.startsWith(base),
    )
  ) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        snackBarService.Error(prepareErrorMessage(error));
        return throwError(() => error);
      }),
    );
  }

  return next(req);
};
